const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const capacitorInVersionParam = urlParams.get('cv') === '5' || urlParams.get('cv') === '7'
const capacitorInUserAgent = window.navigator.userAgent.includes('capacitor/5') || window.navigator.userAgent.includes('capacitor/7')
const useLatestCapacitor = capacitorInUserAgent || capacitorInVersionParam
const Capacitor = useLatestCapacitor ? require('@capacitor/core').Capacitor : require('capacitor-core-legacy').Capacitor
const Plugins = require('capacitor-core-legacy').Plugins

const getCapacitorClientVersion = () => {
  if (capacitorInVersionParam) return urlParams.get('cv')
  if (window.navigator.userAgent.includes('capacitor/5')) return '5'
  if (window.navigator.userAgent.includes('capacitor/7')) return '7'
  return '2'
}

export const CapacitorService = {
  version          : getCapacitorClientVersion(),
  platform         : Capacitor.getPlatform(),
  isPluginAvailable: (name) => Capacitor.isPluginAvailable(name),
  isNativePlatform : () => useLatestCapacitor ? Capacitor.isNativePlatform() : Capacitor.isNative,
  isNative         : useLatestCapacitor ? Capacitor.isNativePlatform() : Capacitor.isNative,
  Plugins          : {
    SplashScreen: useLatestCapacitor ? require('@capacitor/splash-screen').SplashScreen : Plugins.SplashScreen,
    Device      : useLatestCapacitor ? require('@capacitor/device').Device : Plugins.Device,
    Browser     : useLatestCapacitor ? require('@capacitor/browser').Browser : Plugins.Browser,
    App         : useLatestCapacitor ? require('@capacitor/app').App : Plugins.App,
    InAppBrowser: window?.cordova?.InAppBrowser || null
  }
}
